import { useState, useEffect } from 'react';

import { useBsTrapsColumns } from './useSRBMTrapsColumns';
import SRBMTrapExpandable from './SRBMTrapExpandable';

import useScreenSize from 'hooks/Screen/useScreenSize';
import { SRBMTrapData } from 'api/traps/SRBMTraps/types';
import useGetSbsTraps from 'hooks/Traps/SRBMTraps/useGetSRBMTraps';
import TrapDeleteModal from 'components/DeleteTrapModal/TrapsDeleteModal';
import ManageTrapModal from 'pages/Traps/Modals/AddTrapModal/ManageTrapModal';
import EditTrapModal from 'pages/Traps/Modals/EditTrapModalStore/EditTrapModal';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';

interface TableProps {
  slug: string;
}

const SRBMTrapsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetSbsTraps(slug || '', page, search, ordering);

  const columns = useBsTrapsColumns(slug);
  const { isNotLargeDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <FilterDataTable<SRBMTrapData>
        columns={columns}
        data={data || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotLargeDesktop}
        expandableRowsComponent={row => <SRBMTrapExpandable data={row.data} slug={slug} />}
      />
      <TrapDeleteModal refetchTraps={refetch} />
      <ManageTrapModal refetchTraps={refetch} />
      <EditTrapModal refetchTraps={refetch} />
    </div>
  );
};

export default SRBMTrapsTable;
